import * as React from 'react';
import { GridApiContext } from '../components/GridApiContext';
import { GridRootPropsContext } from './GridRootPropsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridContextProvider = ({
  apiRef,
  props,
  children
}) => {
  return /*#__PURE__*/_jsx(GridRootPropsContext.Provider, {
    value: props,
    children: /*#__PURE__*/_jsx(GridApiContext.Provider, {
      value: apiRef,
      children: children
    })
  });
};


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/context/GridContextProvider.js
// module id = 1090
// module chunks = 25